if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        this.setUpPickupAvailability();
      }

      connectedCallback() {
        this.opener = this.querySelector('modal-opener');
        this.setSecondaryLink();
      }

      setUpPickupAvailability() {
        this.opener = this.querySelector('modal-opener');
        this.setSecondaryLink();

        if (!this.hasAttribute('available')) return;
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
            this.renderPreview(html);
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderPreview(html) {
        const drawerContent = document.querySelector('pickup-availability-drawer .product-popup-modal__content-info');
        const newContent = html.querySelector('pickup-availability-drawer .product-popup-modal__content-info');

        const previews = document.querySelectorAll('pickup-availability-preview');
        const newPreview = html.querySelector('pickup-availability-preview');

        if (drawerContent && newContent) {
          drawerContent.innerHTML = newContent.innerHTML;
        }

        if (newPreview) {
          previews.forEach((preview) => {
            preview.innerHTML = newPreview.innerHTML;
          });
          setTimeout(() => {
            this.setUpPickupAvailability();
          }, 100);
        }
      }

      setSecondaryLink() {
        this.links = document.querySelectorAll('a[href="#store-pickup-availability-open"]');

        if (this.links.length <= 0) return;

        if (this.hasAttribute('hide-when-link')) this.classList.add('hidden');

        this.links.forEach((link) => {
          if (document.querySelector('.pickup-availability-preview')?.classList.contains('no-store-available')) {
            link.classList.add('hidden');
            return;
          }

          link.classList.remove('hidden');
          link.addEventListener('click', (event) => {
            event.preventDefault();
            this.opener.trigger(link);
          });
        });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends ModalDialog {
      constructor() {
        super();
      }
    }
  );
}
